module.exports = __webpack_public_path__ + "img/waitingIcon.edf4241f.gif";